import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  loader: {
    marginTop: '25%',
  },
}));

export default useStyles;
